import useFormatDateTime from '@/utils/hooks/format/useFormatDateTime';
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

//components
import H3 from '@/components/base/Headings/H3';
import { Receipts } from '@/components/pages/settings/subscription-invoices/PageContent/Components/Receipts';
import { Subscription } from '@/components/pages/settings/subscription-invoices/PageContent/Components/Subscription';
import { UserBilling } from '@/components/pages/settings/subscription-invoices/UserBilling';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';

export type FormatDateType = (date: string) => string;

type RightSectionProps = {
    togglePlanModal: () => void;
};

function RightSectionContent({ togglePlanModal }: RightSectionProps) {
    const { t } = useTranslation('settings');
    const { user } = useUser({
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const { formatDateTime } = useFormatDateTime(user.settings?.timezone);
    const formatDate: FormatDateType = (date: string) => {
        return formatDateTime(date, `${user.settings?.date_format}_inLetters`);
    };

    return (
        <>
            <div className="border-b border-icoGray-300 p-8 dark:border-icoDarkMode-beton xl:px-7 xl:py-10 xl:pb-10">
                <H3 className="mb-m">{t('subscription_invoices_page.subscription')}</H3>
                <Subscription formatDate={formatDate} togglePlanModal={togglePlanModal} />
            </div>
            <div className="border-b border-icoGray-300 p-8 dark:border-icoDarkMode-beton xl:px-7 xl:py-10">
                <H3 className="mb-m">{t('subscription_invoices_page.invoices')}</H3>
                <Receipts formatDate={formatDate} />
            </div>
            <div className="p-8 xl:px-7 xl:py-10 xl:pb-10">
                <H3 className="mb-m">{t('subscription_invoices_page.billing')}</H3>
                <UserBilling />
            </div>
        </>
    );
}

export function RightSection({ togglePlanModal }: RightSectionProps) {
    return (
        <SettingsWrapper.SideContent>
            <RightSectionContent togglePlanModal={togglePlanModal} />
        </SettingsWrapper.SideContent>
    );
}
